import React from "react";
import StickyPack from "./Stickies/StickyPacks";
import QuickKit from "./Series/QuickKit";

function StickiesTools({ boardSelection, userIsPro, environment }) {
  return (
    <div className="scrollable mt-0">
      <StickyPack
        boardSelection={boardSelection}
        userIsPro={userIsPro}
        environment={environment}
      />
      {/* <QuickKit stickyOnly={true} /> */}
    </div>
  );
}

export default StickiesTools;
